/**
 * report-dialog-single.js
 */

import React from 'react';
import { useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { Types } from 'utils/constants';
import Dialog from 'components/dialog';
import ReportFrame from './report-frame';
import { ReportSourceType, ReportRunType, ReportType, reportAnalytics } from './report-constants';


const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiDialog-paper': {
      height: '100%',
      transition: '300ms ease-out'
    },
    '& .MuiDialogContentText-root': {
      height: '100%',
      marginBottom: 0,
    }
  },
  content: {
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  }
}));


export default function ReportDialogSingle(props) {
  const {
    recordGroup,
    recordIds,
    onClose,
    ...rest
  } = props;
  const classes = useStyles();
  const { t } = useTranslation('general');
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'), { noSsr: true });
  const reportType = recordGroup === Types.RecordGroup.TRAINING
    ? ReportType.EXERCISE_DETAIL
    : recordGroup === Types.RecordGroup.DEPLOYMENT
      ? ReportType.DEPLOYMENT_DETAIL
      : recordGroup === Types.RecordGroup.CLASS
        ? ReportType.CLASS_DETAIL
        : recordGroup === Types.RecordGroup.VET_VISIT
          ? ReportType.VET_VISIT_DETAIL
          : null;
  const isOpen = Boolean(recordGroup && reportType && recordIds);


  // init
  React.useEffect(() => {
    if (isOpen) {
      reportAnalytics(ReportSourceType.SINGLE, ReportRunType.VIEW, null, reportType, recordIds.length, t);
    }
  }, [isOpen, reportType, recordIds, t]);


  return (
    <>
      <Dialog
        className={classes.root}
        title='View Report'
        data-testid='report-dialog'
        maxWidth='md'
        fullWidth={true}
        fullScreen={isMobile}
        open={isOpen}
        okLabel={'Close'}
        showCancel={false}
        // actionsPadding={24}
        onOk={() => onClose()}
        onClose={() => onClose()}
        contentProps={{ className: classes.content }}
        {...rest}
      >
        <ReportFrame
          doRun={isOpen}
          reportSourceType={ReportSourceType.SINGLE}
          params={{
            reportType,
            recordGroups: [recordGroup],
            completionIds: recordGroup === Types.RecordGroup.TRAINING ? recordIds : 0,
            deploymentIds: recordGroup === Types.RecordGroup.DEPLOYMENT ? recordIds : 0,
            classIds: recordGroup === Types.RecordGroup.CLASS ? recordIds : 0,
            vetVisitIds: recordGroup === Types.RecordGroup.VET_VISIT ? recordIds : 0,
          }}
        />
      </Dialog>
    </>
  )
}